import type { SVGProps } from "react";

export function Snowflake(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Center hexagon */}
      <path d="M12 8 L14.5 9.5 L14.5 12.5 L12 14 L9.5 12.5 L9.5 9.5 Z" />

      {/* 6 main branches radiating from center */}
      {/* Top branch */}
      <line x1="12" y1="8" x2="12" y2="2" />
      <line x1="12" y1="4" x2="10.5" y2="5" />
      <line x1="12" y1="4" x2="13.5" y2="5" />

      {/* Top-right branch */}
      <line x1="14.5" y1="9.5" x2="18.5" y2="6.5" />
      <line x1="17" y1="7.5" x2="16" y2="8.5" />
      <line x1="17" y1="7.5" x2="17.5" y2="9" />

      {/* Bottom-right branch */}
      <line x1="14.5" y1="12.5" x2="18.5" y2="15.5" />
      <line x1="17" y1="14.5" x2="17.5" y2="13" />
      <line x1="17" y1="14.5" x2="16" y2="13.5" />

      {/* Bottom branch */}
      <line x1="12" y1="14" x2="12" y2="20" />
      <line x1="12" y1="18" x2="10.5" y2="17" />
      <line x1="12" y1="18" x2="13.5" y2="17" />

      {/* Bottom-left branch */}
      <line x1="9.5" y1="12.5" x2="5.5" y2="15.5" />
      <line x1="7" y1="14.5" x2="8" y2="13.5" />
      <line x1="7" y1="14.5" x2="6.5" y2="13" />

      {/* Top-left branch */}
      <line x1="9.5" y1="9.5" x2="5.5" y2="6.5" />
      <line x1="7" y1="7.5" x2="6.5" y2="9" />
      <line x1="7" y1="7.5" x2="8" y2="8.5" />
    </svg>
  );
}
